import { getGenericEndpoint } from './get.api';
import type { GetForgotPasswordResponse } from './types';

export const getForgotPassword = async (lang?: string, pwrt?: string) => {
	const path = `forgotten${pwrt ? '/reset' : ''}`;

	return await getGenericEndpoint<GetForgotPasswordResponse>(path, lang);
};
